<template>

    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-account-group</v-icon>
                    Usuários
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="paginationOptions.search"
                        class="mr-3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        placeholder="Informe o Nome para busca"
                        single-line
                        hide-details
                        @keydown="buscar()"
                        @click:append="buscar()"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-switch
                        v-model="users.active"
                        :label=" `Exibindo ${users.active? 'Ativos': 'Inativos'}`"
                        single-line
                        hide-details
                        class="mr-3"
                        style="width: 200px"
                        @change="buscar()"
                    ></v-switch>
                    <v-btn
                        color="#3D1159"
                        dark
                        :to="{ name: 'usersCreate' }"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>
                <v-alert type="warning" outlined v-show="!users.items"
                >Nenhum Usuário Encontrado
                </v-alert
                >
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredUsersItems()"
                    :options.sync="options"
                    :server-items-length="users.totalItems"
                    :search.sync="paginationOptions.search"
                    item-key="id"
                    class="elevation-1"
                    v-show="users.items"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.value="{ item }">
                        {{ item.value | money }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'user', params: { id: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                    <!-- <template v-slot:item.actions="{ item }">
                         <v-tooltip bottom>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn
                                     icon
                                     class="btn-lyndus"
                                     v-bind="attrs"
                                     v-on="on"
                                     :to="{ name: 'usersEdit', params: { id: item.id } }"
                                 >
                                     <v-icon>mdi-pencil</v-icon>
                                 </v-btn>
                             </template>
                             <span>Editar</span>
                         </v-tooltip>
                     </template>-->
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";

import {USERS_GET, USER_SEARCH} from "@/store/actions/user.type";
import {SET_USER_PAGINATION, USER_RESET_STATE} from "@/store/mutations/user.type";

export default {
    name: "ListarUsuarios",
    directives: {mask},
    props: {
        source: String
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(USER_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch(USER_RESET_STATE),
            store.dispatch(USERS_GET)
        ]).then(() => {
            next();
        });
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/users')){
            localStorage.removeItem('usersOptions')
            localStorage.removeItem('userPaginationOptions')

        }
    },
    data: () => ({
        //Lista de Usuários

        options: {},
        paginationOptions: {},
        selected: [],
        headers: [
            {text: "Nome", align: "left", value: "name"},
            {text: "E-mail", value: "email"},
            {text: "Telefone", value: "phone"},
            {text: "Usuário", value: "username"},
            {text: "Visualizar", value: "actions", sortable: false}
        ],

        formIsValid: false,

        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        
        emailRules: [
            v => !!v || "E-mail é obrigatório",
            value => {
                if (typeof value !== "undefined" && value.length > 0) {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Informe um email válido";
                }
                return false;
            }
        ]
    }),
    methods: {
        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options
            this.userPagination.search = this.paginationOptions.search

            store.commit(SET_USER_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            store.dispatch(USER_SEARCH);
        },
        filteredUsersItems() { 
            const items = this.users.items
            const search = this.userPagination.search ? this.userPagination.search.toLowerCase() : ""
            if(search){
                this.options.itemsPerPage = this.users.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else {
                if(this.options.itemsPerPage == this.users.totalItems){
                    this.options.itemsPerPage = 10
                }
                return items;
            } 
        },

        reset() {
            this.$refs.formUsuario.reset();
        }
    },
    mounted() {
        if (localStorage.getItem('usersOptions')){
            this.options = JSON.parse(localStorage.getItem('usersOptions'))
        }
        if (localStorage.getItem('userPaginationOptions')){
            this.paginationOptions = JSON.parse(localStorage.getItem('userPaginationOptions'))
        }
    },
    watch: {
        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('usersOptions', parsed)
            },
            deep: true,
        },
        paginationOptions: {
            handler(newSearch) {
                this.buscar()
                const parsed = JSON.stringify(newSearch)
                localStorage.setItem('userPaginationOptions', parsed)
            },
            deep: true,
        }
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })
        //             {text: "Data", align: "left", value: "requestDate"},
// {text: "Saldo Liberado", value: "valueReleased"},
// {text: "Valor Antecipado", value: "valueAnticipation"},
// {text: "Valor Total", value: "totalValue"},
// // {text: "Usuário", value: "username"},
// {text: "Visualizar", value: "actions", sortable: false}
        

        ...mapGetters(["users", "checkUsers", "userPagination"])
    },

};
</script>
